import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getIdentifiedUserCustomEvents } from '@hotjar/site';
import type { Site, IdentifiedUserCustomEvents } from '@hotjar/site';

export const IDENTIFIED_USERS_CUSTOM_EVENT_QUERY_KEY = 'identifiedUsersCustomEventsApi';

export function useIdentifiedUsersCustomEvents(
  site: Site | undefined,
): UseQueryResult<IdentifiedUserCustomEvents, Error> {
  return useQuery({
    queryKey: `${IDENTIFIED_USERS_CUSTOM_EVENT_QUERY_KEY}-${site?.id}`,
    queryFn: () => getIdentifiedUserCustomEvents(site?.id ?? 0),
    enabled: site != null,
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
